// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__2Oyqm","container":"LayoutSideNavigation_container__YDuEr","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__1Dowk"};